import * as validators from "@vuelidate/validators"
import i18n from "@/plugins/i18n"
import Helper from "@/services/Helper"

// 👉 экспортируем helpers для кастомных валидаторов
export const { helpers } = validators

// 👉 createI18nMessage используем ТОЛЬКО здесь
const withI18nMessage = validators.createI18nMessage({
    t: i18n.global.t.bind(i18n),
})

// --------------------
// Базовые валидаторы
// --------------------

export const required = withI18nMessage(validators.required, {
    withArguments: true,
})
export const requiredIf = withI18nMessage(validators.requiredIf, {
    withArguments: true,
})
export const between = withI18nMessage(validators.between, {
    withArguments: true,
})

export const minLength = withI18nMessage(validators.minLength, {
    withArguments: true,
})

export const minValue = withI18nMessage(validators.minValue, {
    withArguments: true,
})

export const maxValue = withI18nMessage(validators.maxValue, {
    withArguments: true,
})

export const url = withI18nMessage(validators.url, {
    withArguments: true,
})

export const maxLength = withI18nMessage(validators.maxLength, {
    withArguments: true,
    messageParams: ({ max }) => ({
        max,
        word: Helper.plural(max, "символ", "символа", "символов"),
    }),
})

export const integer = withI18nMessage(validators.integer, {
    withArguments: true,
})

// --------------------
// Кастомные валидаторы
// --------------------

const _fileSize = (options = {}) =>
    helpers.withParams(options, value => {
        if (!value) return true

        const fileSizeinKb = value.size / 1024
        const size = Math.round(fileSizeinKb * 100) / 100

        return size <= options.maxFileSizeInB / 1024
    })

export const fileSize = withI18nMessage(_fileSize, {
    withArguments: true,
})

const _selectRequired = value => {
    return value !== 0 && value !== null && value !== undefined && value !== '';
}

export const selectRequired = withI18nMessage(_selectRequired)
